import websocket from 'locales/services/websocket'

export default {
  websocket,
}
